<div class="container">
    <div class="row">

        <!-- نشاط المستخدم -->
        <div class="col-12 col-md-6 mb-2">
            <p-card header="نشاط المستخدم (عمليات البحث يومياً)" styleClass="h-full shadow-2">
                <div class="flex flex-column align-items-center">
                    <p-chart type="line" [data]="activityData"
                        [options]="{ responsive: true, plugins: { legend: { display: false } } }"
                        style="width:100%;max-width:400px"></p-chart>
                </div>
            </p-card>
        </div>

        <!-- تسجيل الدخول -->
        <div class="col-12 col-md-6 mb-2">
            <p-card header="تسجيل دخول المستخدم (أسبوعياً)" styleClass="h-full shadow-2">
                <div class="flex flex-column align-items-center">
                    <p-chart type="bar" [data]="loginData"
                        [options]="{ responsive: true, plugins: { legend: { display: false } } }"
                        style="width:100%;max-width:400px"></p-chart>
                </div>
            </p-card>
        </div>

        <!-- إحصائيات التدريب -->
        <div class="col-12 mb-2">
            <p-card header="إحصائيات التدريب" styleClass="shadow-2">
                <div class="row text-center gap-2 mb-4 px-2">
                    <div class="col card py-4 flex flex-column align-items-center">
                        <span class="font-bold text-primary">الحضور</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ trainingStats.attended }}</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <span class="font-bold text-primary">القادمة</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ trainingStats.upcoming }}</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <span class="font-bold text-primary">المفات</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ trainingStats.missed }}</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <span class="font-bold text-primary">الناجحة</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ trainingStats.passed }}</h3>
                    </div>
                    <div class="col card py-4    flex flex-column align-items-center">
                        <span class="font-bold text-primary">الفاشلة</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ trainingStats.failed }}</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <span class="font-bold text-primary">المعدل</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ trainingStats.avgGrade }}%</h3>
                    </div>
                </div>

                <p-table [value]="trainingBreakdown" class="mt-4 p-datatable-sm p-datatable-striped" [paginator]="true"
                    [rows]="5" styleClass="shadow-1">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>اسم التدريب</th>
                            <th>الحالة</th>
                            <th>التاريخ</th>
                            <th>الدرجة</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-training>
                        <tr>
                            <td>{{ training.name }}</td>
                            <td>
                                <span [ngClass]="{
                                'badge bg-success': training.status === 'ناجح',
                                'badge bg-warning': training.status === 'قادم',
                                'badge bg-danger': training.status === 'فاشل',
                                'badge bg-secondary': training.status !== 'ناجح' && training.status !== 'قادم' && training.status !== 'فاشل'
                            }">{{ training.status }}</span>
                            </td>
                            <td>{{ training.date }}</td>
                            <td>
                                <span class="font-bold">{{ training.grade }}</span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-card>
        </div>

        <!-- نتائج التقييم كصف من البطاقات الصغيرة -->
        <div class="col-12 mb-2">
            <p-card header="نتائج التقييم" styleClass="h-full shadow-2">
                <div class="row text-center gap-4 mb-4 px-2">
                    <div class="col card py-4 flex flex-column align-items-center">
                        <i class="pi pi-check-circle text-primary mb-2 text-2xl"></i>
                        <span class="font-bold text-primary">عدد الاختبارات</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ assessmentStats.attempted }}</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <i class="pi pi-question-circle text-info mb-2 text-2xl"></i>
                        <span class="font-bold text-info">عدد الأسئلة</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ assessmentStats.totalQuestions }}</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <i class="pi pi-thumbs-up text-success mb-2 text-2xl"></i>
                        <span class="font-bold text-success">إجابات صحيحة</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ assessmentStats.correctAnswers }}</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <i class="pi pi-percentage text-warning mb-2 text-2xl"></i>
                        <span class="font-bold text-warning">المعدل</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ assessmentStats.avgGrade }}%</h3>
                    </div>
                    <div class="col card py-4 flex flex-column align-items-center">
                        <i class="pi pi-clock text-secondary mb-2 text-2xl"></i>
                        <span class="font-bold text-secondary">متوسط الوقت</span>
                        <h3 class="mt-2 mb-0 text-2xl">{{ assessmentStats.avgTime }}</h3>
                    </div>
                </div>
            </p-card>
        </div>

        <!-- نتائج الاستبيانات -->
        <div class="col-12 mb-2">
            <p-card header="نتائج الاستبيانات" styleClass="h-full shadow-2">
            <div class="row text-center gap-4 mb-4">
                <div class="col card py-4 flex flex-column align-items-center">
                <i class="pi pi-list text-primary mb-2 text-2xl"></i>
                <span class="font-bold text-primary">عدد الاستبيانات</span>
                <h3 class="mt-2 mb-0 text-2xl">{{ surveyStats.totalTaken }}</h3>
                </div>
                <div class="col card py-4 flex flex-column align-items-center">
                <i class="pi pi-check text-success mb-2 text-2xl"></i>
                <span class="font-bold text-success">عدد الأسئلة المجابة</span>
                <h3 class="mt-2 mb-0 text-2xl">{{ surveyStats.totalQuestions }}</h3>
                </div>
            </div>
            </p-card>
        </div>

    </div>
</div>